import Controller from './controller'
import anime from 'animejs'

export default class extends Controller {
  static targets = ['chevron', 'rect']

  static options = {
    multipleOpen: false,
  }

  initialize() {
    this.obj = JSON.parse(this.element.getAttribute('data-options'))

    if (this.hasChevronTarget) {
      this.init()
    }
  }

  init() {
    for (let index = 0; index < this.chevronTargets.length; index++) {
      const element = this.chevronTargets[index]
      let motion_path = anime.path(this.obj.path)

      const anim = anime({
        targets: element,
        translateX: motion_path('x'),
        translateY: motion_path('y'),
        rotate: motion_path('angle'),
        easing: 'linear',
        loop: true,
        duration: this.obj.duration
      })

      anim.pause()

      if (this.obj.offset) {
        setTimeout(() => {
          anim.play()
        }, this.obj.offset);
      } else {
        anim.play()
      }
    }
  }
}
